import { useTheme } from '@emotion/react'
import {
    DataLayerEventName,
    Product,
    toRadioEvent,
} from '@news-mono/web-common'
import React, { FC, useContext } from 'react'
import { useLocation } from 'react-router'
import { TheWestLivePlayer } from '../../../content/TheWestLive/TheWestLivePlayer/TheWestLivePlayer'
import { LivePlayerButtonOnly } from '../../../content/TheWestLive/TheWestLivePlayer/TheWestLivePlayerSkin/TheWestLivePlayerSkin'
import {
    TheWestLiveContext,
    useInProgrammedScheduleWindow,
    useOnAirState,
} from '../../../content/TheWestLive/TheWestLiveProvider'
import { ThemeMargins } from '../../../__styling/settings/metrics'
import { SponsoredLogoContainer } from '../TheWestLiveStickyBanner/TheWestLiveStickyBanner.styled'
import { TheWestLiveWaves } from '../TheWestLiveWaves/TheWestLiveWaves'
import TheWestLiveBillboardBanner from './components/TheWestLiveBillboardBanner'
import {
    StyledSponsorLogo,
    StyledWestLiveBillboardContainer,
    StyledWestLiveBillboardLogoAndPlayerContainer,
    StyledWestLiveBillboardPlayerContainer,
    StyledWestLiveBillboardWrapper,
} from './TheWestLiveBillboard.styled'

const sponsorLogoPn = require('../LivePlayer/Sponsorship/assets/walga-twl-logo-west-black.png')
const sponsorLogoTw = require('../LivePlayer/Sponsorship/assets/walga-twl-logo-west-blue.png')

export interface TheWestLiveBillboardProps {
    showSponsorLogo?: boolean
    verticalSpacing?: [keyof ThemeMargins, keyof ThemeMargins] | undefined // [marginTop,marginBottom]
}

export const TheWestLiveBillboard: FC<TheWestLiveBillboardProps> = (props) => {
    const { showSponsorLogo, verticalSpacing } = props
    const { playerState, setPlayerState, onEvent } =
        useContext(TheWestLiveContext)
    const { search } = useLocation()
    const { onAir, broadcast } = useOnAirState()
    const { kind } = useTheme()

    const hasWestLiveQuery = search.indexOf('the_west_live') !== -1
    const inScheduledWindow =
        useInProgrammedScheduleWindow() || hasWestLiveQuery

    function handleControlClick() {
        setPlayerState({
            ...playerState,
            state: playerState.state === 'stopped' ? 'loading' : 'stopped',
        })

        onEvent(
            toRadioEvent(
                playerState.state === 'stopped'
                    ? DataLayerEventName.radioPlay
                    : DataLayerEventName.radioStop,
                broadcast,
                'card',
            ),
        )
    }

    if (!inScheduledWindow || (inScheduledWindow && !onAir)) {
        return null
    }

    return (
        <StyledWestLiveBillboardWrapper
            verticalSpacing={verticalSpacing}
            broadcast={broadcast}
        >
            <StyledWestLiveBillboardContainer>
                <StyledWestLiveBillboardLogoAndPlayerContainer
                    broadcast={broadcast}
                >
                    <TheWestLiveBillboardBanner broadcast={broadcast} />
                    <StyledWestLiveBillboardPlayerContainer>
                        <TheWestLivePlayer
                            PlayerSkin={(props) => (
                                <LivePlayerButtonOnly
                                    {...props}
                                    onControlClick={handleControlClick}
                                />
                            )}
                        />
                    </StyledWestLiveBillboardPlayerContainer>
                </StyledWestLiveBillboardLogoAndPlayerContainer>

                {showSponsorLogo && (
                    <SponsoredLogoContainer>
                        <StyledSponsorLogo
                            src={
                                kind === Product.PerthNow
                                    ? sponsorLogoPn
                                    : sponsorLogoTw
                            }
                        />
                    </SponsoredLogoContainer>
                )}
            </StyledWestLiveBillboardContainer>
            <TheWestLiveWaves broadcast={broadcast} />
        </StyledWestLiveBillboardWrapper>
    )
}
TheWestLiveBillboard.displayName = 'TheWestLiveInArticleBanner'

export default TheWestLiveBillboard
